import _extends from "@babel/runtime-corejs3/helpers/extends";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { useState, useEffect } from 'react';
import { TextInput } from '@rexlabs/text-input';
import { StylesProvider } from '@rexlabs/styling';
import { isValidDate, formatDateValue, DEFAULT_DISPLAY_FORMAT, SUPPORTED_DATE_FORMATS } from './core';
var overrides = {};

function DateInput(_ref) {
  var _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$onBlur = _ref.onBlur,
      _onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      value = _ref.value,
      _ref$displayFormat = _ref.displayFormat,
      displayFormat = _ref$displayFormat === void 0 ? DEFAULT_DISPLAY_FORMAT : _ref$displayFormat,
      _ref$supportedFormats = _ref.supportedFormats,
      supportedFormats = _ref$supportedFormats === void 0 ? SUPPORTED_DATE_FORMATS : _ref$supportedFormats,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'YYYY/MM/DD' : _ref$placeholder,
      _ref$clearInvalidInpu = _ref.clearInvalidInput,
      clearInvalidInput = _ref$clearInvalidInpu === void 0 ? true : _ref$clearInvalidInpu,
      props = _objectWithoutProperties(_ref, ["onChange", "onBlur", "value", "displayFormat", "supportedFormats", "placeholder", "clearInvalidInput"]);

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      displayValue = _useState2[0],
      setDisplayValue = _useState2[1];

  useEffect(function () {
    setDisplayValue(value);
  }, [value, setDisplayValue]);
  return /*#__PURE__*/React.createElement(StylesProvider, {
    components: overrides
  }, /*#__PURE__*/React.createElement(TextInput, _extends({
    value: displayValue,
    onChange: function onChange(e) {
      var _context;

      setDisplayValue(e.target.value);
      var date = isValidDate(e.target.value, _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(supportedFormats), [displayFormat]));

      if (date) {
        _onChange({
          persist: function persist() {
            return null;
          },
          target: {
            value: date
          }
        });
      }
    },
    onBlur: function onBlur(e) {
      var _context2;

      var date = isValidDate(displayValue, _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(supportedFormats), [displayFormat]));
      var value = formatDateValue(date, displayFormat);
      var fallback = clearInvalidInput ? '' : displayFormat;
      setDisplayValue(value || fallback);

      _onBlur(e);
    },
    placeholder: placeholder
  }, props)));
}

export default DateInput;